import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { HeaderService } from "src/app/_services/header.service";
import { HeaderModel } from "../../_component/header/header.model";
import { UserService } from "../../_services";
import { ThisPlatform } from "../../_services/platform.service";
import { RowsLoaderService } from "../../_services/rows-loader.service";
import { PaginationClientSideOptions } from "../_component/pagination-client-side/pagination-client-side-options";
import { PaginationColumn } from "../_component/pagination-client-side/pagination-column.class";
import { BuildingViewComponent } from "./building-view/building-view.component";
import { Building } from "./building.model";
import { BuildingService } from "./building.service";

@Component({
  selector: "app-building",
  templateUrl: "./building.page.html",
  styleUrls: ["./building.page.scss"],
})
export class BuildingPage implements OnInit {
  constructor(
    public buildingServ: BuildingService,
    private userServ: UserService,
    public p: ThisPlatform,
    public translateServ: TranslateService,
    private headerServ: HeaderService,
  ) {}

  componentRef: any = BuildingViewComponent;

  buildingFilter: Building[];
  buildingAddRole = false;
  showLoader: boolean = true;
  columnsDefinition: PaginationColumn[] = [
    {
      name: "logo",
      displayName: "Logo",
      size: 2,
      sortable: false,
    },
    {
      name: "name",
      displayName: "BUILDING.NAME",
      size: 3,
      sortable: true,
    },
    {
      name: "street",
      displayName: "BUILDING.STREET",
      size: 2,
      sortable: true,
    },
    {
      name: "city",
      displayName: "BUILDING.CITY",
      size: 2,
      sortable: true,
    },
    {
      name: "description",
      displayName: "BUILDING.DESCRIPTION",
      size: 3,
      sortable: true,
      colValue: (row) => {
        return row.description;
      },
    },
  ];

  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    headerStickyPosition: 58,
    addButtonText: "BUILDING.ADD_BUILDING",
    noResultsAddLink: "/app/building/add",
    permissionAdd: "building.add"
  };

  rowsLoader: RowsLoaderService;

  @ViewChild("searchBar")
  searchBar;

  async ngOnInit() {
    this.buildingAddRole = await this.userServ.hasRolesAsync(["building.add"]);
  }
  
  ionViewWillEnter() {
    this.headerServ.setHeaderInit({
      title: "MENU.BUILDINGS",
    });
    this.loadBuildings()
  }
  
  async loadBuildings() {
    this.showLoader = true;
    await this.buildingServ.loadBuildingsSync(true);
    this.buildingFilter = this.buildingServ.buildings;
    this.rowsLoaderInit();
  }

  rowsLoaderInit() {
    if (this.rowsLoader) {
      if (this.searchBar.ngModel) {
        this.buildingFilter = this.buildingServ.buildings.filter(
          (s) =>
            (
              s.name.toUpperCase() +
              " " +
              s.street.toUpperCase() +
              " " +
              s.city.toUpperCase() +
              " " +
              (s.description ? s.description.toUpperCase() : "")
            ).includes(this.searchBar.ngModel.toUpperCase())
        );
      } else {
        this.buildingFilter = this.buildingServ.buildings;
      }

      this.rowsLoader.init(this.buildingFilter);
      this.showLoader = false;
    }
  }

  onChangeSearch() {
    this.rowsLoaderInit();
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }
}
